import React from 'react'
import { useFormContext } from 'react-hook-form'

const CalendlyScheduleEvent = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext()

  return (
    <div className='select-action'>
      <div className='label'>Enter scheduling link</div>
      <input
        type='text'
        className='form-control'
        placeholder='https://calendly.com/<event>'
        {...register('action.event_url', {
          required: {
            value: true,
            message: 'Scheduling link is required'
          },
          pattern: {
            value: /https:\/\/calendly.com\/(.+)/,
            message: 'Invalid scheduling link'
          },
          shouldUnregister: true
        })}
      />
      {errors.action?.event_url && <small className='ml-2 text-danger'>{errors.action.event_url.message}</small>}
    </div>
  )
}

export default CalendlyScheduleEvent
